/**
 * 環境名とコンポーネントのMapを取得する
 *
 * @param {Object[]} replacements コンポーネントの配列
 * @returns Map<string, Object>
 */
const getEnvNameMap = replacements => {
  const map = new Map()
  replacements.forEach(replacement => {
    const splittedNames = replacement.name.split('_')
    if (splittedNames.length !== 2) {
      console.error(
        `_の数が不正なため、envの切り替えに失敗しました。 splittedNames: ${splittedNames}`,
      )
      // 失敗パターンはそのまま返す
      map.set(replacement.name, replacement)
      return
    }
    map.set(splittedNames[1], replacement)
  })
  return map
}

/**
 * 環境でコンポーネントを切り替える\
 * 注意:\
 * 	コンポーネント名(replacement.name)の中の区切り文字『_』で区切られた接尾語により環境を特定する。\
 * 	環境変数は『.env』の『VUE_APP_LOCATION』を参照し、判定する。\
 * 例:\
 * 	Auth_TOKYO => TOKYOを環境変数名とする。
 *
 *
 * @param {Object} defaultUI デフォルトのコンポーネント（必須）
 * @param {array} replacements 環境によって切り替えたいコンポーネントの配列（オプショナル）
 * @returns Object 一致したコンポーネント
 */
export const injectFromLocation = (defaultUI, replacements = []) => {
  // validate
  const validReplacements = replacements.every(
    replacement => !!replacement.name,
  )
  if (replacements.length === 0 || !validReplacements) {
    return defaultUI
  }

  // create map
  const envNameMap = getEnvNameMap(replacements)

  // get component
  const envName = process.env.VUE_APP_LOCATION
  const component = envNameMap.get(envName)

  // result
  if (!component) {
    return defaultUI
  }
  return component
}
